module.exports = __webpack_public_path__ + "img/广元市中心医院.a12a0ba2.png";